export default __webpack_public_path__ + "static/media/feature3.12d96dd8.svg";